module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_video_x32-e1e8a.png";